// extracted by css-extract-rspack-plugin
export default {"sectionTitle":"zQwtn7","text":"uL3nn1","highlight":"TNYU7z","hideBackground":"_rBZk8"};